module.exports = __webpack_public_path__ + "static/media/search-ic.42caf811.svg";